import { Route } from "react-router-dom";
import { paths } from "../paths";

export const Routes = () => (
  <>
    {paths.map((item) => (
      <Route
        key={item.path}
        path={item.path}
        exact
        component={() => <>{item.content()}</>}
      />
    ))}
  </>
);
